export {
  getFromPagesForTestId,
  testIdBelongsToFromPage,
  buildCatalogTestIdsByFromPage,
  FROM_PAGES,
  FROM_PAGE_ROUTES,
} from '@/scorecardKb/testIdCatalog';
